define('TescoMobile_Checkout/js/view/incomplete-modal-item',['uiComponent', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', 'mage/translate'], function (Component, $, ko, modal) {
  'use strict';

  return Component.extend({
    modalWindow: null,
    isLoading: ko.observable(true),
    messages: ko.observableArray(),
    tableOpen: false,
    setModalElement: function (element) {
      var options = {
        modalClass: 'incomplete-item show-close',
        responsive: true,
        innerScroll: true,
        type: 'slide',
        clickableOverlay: false,
        opened: function (a, b) {
          this._updateContent(element);
        }.bind(this)
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
    },
    _updateContent: function (element) {
      this.isLoading(false);
    }
  });
});

